// The slate pill shown after a row's description (Trade, Internal, Unsettled).
export const BADGE_CLASS =
  'ml-1.5 inline-flex shrink-0 items-center rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 align-middle text-xs font-medium text-slate-600'
